var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.2913 5.83301V13.333C17.2913 14.233 16.7747 15.008 16.0247 15.383C16.033 15.258 16.0413 15.133 16.0413 14.9997V7.49967C16.0413 5.54967 14.4497 3.95801 12.4997 3.95801H5.52467C5.90801 3.21634 6.67467 2.70801 7.56634 2.70801H14.1663C15.8913 2.70801 17.2913 4.10801 17.2913 5.83301ZM12.4997 5.20801H4.99967C3.73551 5.20801 2.70801 6.23551 2.70801 7.49967V14.9997C2.70801 16.2638 3.73551 17.2913 4.99967 17.2913H12.4997C13.7638 17.2913 14.7913 16.2638 14.7913 14.9997V7.49967C14.7913 6.23551 13.7638 5.20801 12.4997 5.20801Z",
    fill: "#71207C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopy);
export default __webpack_public_path__ + "static/media/icon_copy.222b380f3bd7c0a38057ae44fcb03cb2.svg";
export { ForwardRef as ReactComponent };